import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Helmet } from "react-helmet";
import { useHistory,Link, Redirect } from "react-router-dom";

function ViewKingdom() {
  	const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
	const kds = [];
	let history = useHistory();
	useEffect(() => {
		getkingdomData();
	}, []);
	const [kingdomData, setKingdomData] = useState({"status":"failuer","war_message":"e"});
	const [error1, setError] = useState(false);
	const [availableWarKd, setAvailableWarKd] = useState('');
	const [warStartTime, setwarStartTime] = useState(new Date());
	const [kdImage, setKdImage] = useState("");
	const [kdName, setKdName] = useState("");
	const [msg, setMsg] = useState("");
	const [redirect,setRedirect] = useState("");
	const timeLeftToWar = () => {
		const difference = +warStartTime - +new Date();
		let timeLeft = {};

		if (difference > 0) {
		timeLeft = {
			days: Math.floor(difference / (1000 * 60 * 60 * 24)),
			hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
			minutes: Math.floor((difference / 1000 / 60) % 60),
			// seconds: Math.floor((difference / 1000) % 60),
		};
		}

		return timeLeft;
	};
	const [timeLeft, setTimeLeft] = useState(timeLeftToWar());
	useEffect(() => {
		const interval = setInterval(() => {
		  setTimeLeft(timeLeftToWar());
		}, 1000);
		return () => clearInterval(interval);
	});
	const timerComponents = [];
	let i =10000;
	Object.keys(timeLeft).forEach((interval) => {
		if (!timeLeft[interval]) {
		  return;
		}
	
		timerComponents.push(
		  <a key={i}>
			{timeLeft[interval]} {interval}{" "}
		  </a>
		);
		i++;
	});
	function warzone(params, isLeader){
		console.log(isLeader);
		if(isLeader == 0){
			setKdImage(params.kd_image);
			setKdName(params.name);
			setMsg("Check out kingdom "+params.name+". Lets's go to war them.");
			console.log(kdName);
		}
	}
	function closeMOdal(kingdomData){
		setRedirect(<Redirect to={{
			pathname:"/chat",
			state: [kingdomData,"send",msg]
		}}  />);
	}
	const getkingdomData = async () => {
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id},
			body: JSON.stringify({dist_user_id:user_id}),
			
		};

		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-kingdom-details', requestOptions);
		const data = await response.json();
		if (data.status !== "success"){
			setError(true);
			console.log(error1);
		}
		let j = 1;
		// for (const [index, value] of data.avail_war_kd.entries()) {
		// 	if(j <= 3){
		// 		var modal = 
		// 			<div className="card-img-overlay" data-toggle="modal" data-target="#bottom_modal">
		// 				<div className="overlay-caption">
		// 					<p className="card-heading mb-0">Kingdom</p>
		// 					<p className="card-sub-heading mb-0" style={{overflowWrap:`break-word`, width:`100px`}}>{value.name}</p>
		// 				</div>
		// 			</div>; 
		// 		if(data.is_leader == 1){
		// 			modal = 
		// 			<Link to={{
		// 				pathname:"/war-zone",
		// 				state: [value, data]
		// 			}} >
		// 				<div className="card-img-overlay">
		// 					<div className="overlay-caption">
		// 						<p className="card-heading mb-0">Kingdom</p>
		// 						<p className="card-sub-heading mb-0">{value.name}</p>
		// 					</div>
		// 				</div>
		// 			</Link>; 
		// 		}
		// 		kds.push(<div className="card"  key={index}  onClick={() => warzone(value, data.is_leader)}>
		// 			<div style = {{
		// 				height: `100%`,
		// 				position:`relative`,
		// 				background:   `url(${value.kd_image})no-repeat`,
		// 				backgroundSize: `cover`,
		// 				backgroundPosition: `center`,
		// 				borderBottomLeftRadius: `6px`,
		// 				borderBottomRightRadius: `6px`,
		// 				borderTopLeftRadius: `6px`,
		// 				borderTopRightRadius: `6px`,
		// 			}}
		// 			></div>
		// 			{modal}
		// 		</div>);
		// 	} else if(j === 4){
		// 		kds.push(
		// 		<div className="card"  key={index}>
		// 			<Link to={{
		// 				pathname:"/available-kingdom",
		// 				state: [data]
		// 			}} >
		// 			<div style = {{
		// 				height: `100%`,
		// 				position:`relative`,
		// 				background:   `url(${require("./../images/See-all.png").default})no-repeat`,
		// 				backgroundSize: `100% 100%`,
		// 				backgroundPosition: `center`,
		// 				borderBottomLeftRadius: `6px`,
		// 				borderBottomRightRadius: `6px`,
		// 				borderTopLeftRadius: `6px`,
		// 				borderTopRightRadius: `6px`,
		// 			}}
		// 			></div>
		// 			<div className="card-img-overlay">
		// 				<div className="overlay-caption">
		// 					<p className="card-heading mb-0">See All</p>
		// 					<p className="card-heading mb-0">Kingdom</p>
		// 				</div>
		// 			</div>
		// 			</Link>
		// 		</div>);
		// 	}
		// 	j++;
		// }
		let waf = data.war_available_from;
		const warStartDate = new Date(waf);
		setwarStartTime(warStartDate);
		// const currentDate = new Date();
		// const difference = +warStartDate- +currentDate;
		// let timeLeft = {};
		// if (difference > 0) {
		// 	timeLeft = {
		// 	  days: Math.floor(difference / (1000 * 60 * 60 * 24)),
		// 	  hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
		// 	  minutes: Math.floor((difference / 1000 / 60) % 60),
		// 	  seconds: Math.floor((difference / 1000) % 60),
		// 	};
		// }
		// console.log(timeLeft);
		setAvailableWarKd(kds);
		setKingdomData(data);
		console.log(data);
	};
    return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/kingdom-unlock.css'}]
	}/>
    <div className="row no-gutters">
	{ error1 === false && (
      	<div className="bg-white application">
        	
			<div 
				style = {{
				minHeight: `230px`,
				backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3)) , url('images/kd_bg.png') `,
				backgroundSize: `100% 100%`,
				// borderBottomLeftRadius: `8px`,
				// borderBottomRightRadius: `8px`,
				// backgroundAttachment: `fixed`,
				display: `block`,
				}}
			>
			<div className="appHeader bg-transparent text-light position-relative">
				<div className="left">
					<a className="headerButton goBack" onClick={() => history.goBack()}>
						<img src={require("./../images/back.png").default} alt="back" className="img-fluid" />
					</a>
				</div>
				<div className="pageTitle">&nbsp;</div>
				<div className="right">
					<Link to="/faq" className="headerButton">
						<img src={require("./../images/faq.png").default} alt="faq" className="img-fluid" />
					</Link>
					<Link to={{
                            pathname:"/war-history",
                            state: [kingdomData]
                        }} className="headerButton">
						<img src={require("./../images/refresh.png").default} alt="history" className="img-fluid" />
					</Link>
				</div>
				<div className="section">
					<div className="header-app text-left">
						<p className="mb-0 app-header">
							Kingdom
						</p>
						<p className="mb-0 app-sub-header">
							{kingdomData.kd_name}
						</p>
					</div>            
				</div>
				<div className="section">
				<div className="d-flex cards">
					{/* <div className="card">
						<div className="card-body">
							<p className="mb-0 card-label">Level</p>
							<p className="mb-0 card-value">{kingdomData.kd_level}</p>
						</div>
					</div> */}
					{/* <div className="card">
						<div className="card-body">
							<p className="mb-0 card-label">Wealth</p>
							<p className="mb-0 card-value">{kingdomData.kd_wealth}</p>
						</div>
					</div> */}
					<div className="card">
						<div className="card-body">
							<p className="mb-0 card-label">Wars Won</p>
							<p className="mb-0 card-value">{kingdomData.kd_win_war}/{kingdomData.kd_total_war}<span className="half-font"></span></p>
						</div>
					</div>
				</div>
          	</div>
			</div>
        </div>
        {/* <div className="section mt-20">
		{ kingdomData.war_message === '' && (
            <div>
				<div className="section-title mb-1">Kingdoms available for war</div>
				<div className="scrolling-wrapper">
					{availableWarKd}
				</div>
            </div>
		)}
        </div> */}
        <div className="section">
            <div className="button-group">
				{/* <Link to={{
                            pathname:"/kingdom-stats",
                            state: [kingdomData]
                        }} className="btn btn-red btn-block btn-lg mb-2"> */}
				<p className="btn btn-red btn-block btn-lg mb-2"  data-toggle="modal" data-target="#bottom_modal_new_kd_stats">
                    My Kingdom Stats
                    <img src={require("./../images/right-arrow.png").default} alt="rarrow" className="img-fluid" />
				</p>
                {/* </Link> */}
				<Link to={{
                            pathname:"/chat",
                            state: [kingdomData,"first", ""]
                        }} className="btn btn-blue btn-block btn-lg">
                    Group Updates
                    <img src={require("./../images/group-chat-arrow.png").default} alt="carrow" className="img-fluid" />
				</Link>
            </div>
        </div>
		{/* { kingdomData.war_message !== '' && kingdomData.war_message !== 'e' && (
			<div className="section disabled-section">
            <div className="content">
                <div className="overlay">
                    <p className="mb-0">
                        <img src={require("./../images/lock.png").default} alt="lock" className="d-block m-auto img-fluid" />
                        <span>Kingdoms for war will be available <br /> from 25th</span>
                        <i className="text-white px-3 py-2" id="timer">
							<img src={require("./../images/clock.png").default} alt="clock" className="img-fluid mr-2" />
							{timerComponents.length ? timerComponents : <span>Please refresh page.</span>}

						</i>
                    </p>
                </div>
				<div className="section mt-20">
					<div>
						<div className="section-title mb-1">Kingdoms available for war</div>
						<div className="scrolling-wrapper">
							{availableWarKd}
						</div>
					</div>
				</div>
				
			</div>
			</div>
		)} */}
			<div className="modal bottom fade" id="bottom_modal_new_kd_stats" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-0 px-26 text-center d-block" style={{height: `50px`}}>
                            <h5 className="modal-title">View kingdom stats</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{opacity: `1`,position: `relative`,top: `-20px`}}>
                                <img src={require("./../images/close.png").default} alt="close" className="img-fluid" />
                            </button>
                        </div>
                        <div className="modal-body px-34">
                            <p className="mb-0 desc">This is only available on the day of war.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal bottom fade" id="bottom_modal" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-0 px-26 text-center d-block" style={{height: `50px`}}>
                            <h5 className="modal-title">Share this kingdom</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{opacity: `1`,position: `relative`,top: `-20px`}}>
                                <img src={require("./../images/close.png").default} alt="close" className="img-fluid" />
                            </button>
                        </div>
                        <div className="modal-body px-34">
                            <img src={kdImage} alt="image" className="imaged w69 rounded"/>
                            <p className="mb-0 text-black">Kingdom {kdName}</p>
                            <p className="mb-0 desc">Only King can declare a war against another <br /> Kingdom.</p>
                            <div className="row justify-content-center my-3">
                                <div className="col-8 col-md-8 col-lg-8" >
									<a className="btn btn-apply btn-block" onClick={() =>closeMOdal(kingdomData)}  data-dismiss="modal" aria-label="Close" >
                                    	Share in group chat
									</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
			{redirect}
      </div>
	  )}
	  { error1 === true && (
		  <Redirect to='/'  />
	  )}
	  <div className="bg"></div>
    </div>
</>
    );
}

export default ViewKingdom;
